/*****************************************************************************************************************************************************
 * Message monitoring *
 ****************************************************************************************************************************************************/
define('commons/monitoring/message-monitoring',['jquery', 'commons/monitoring/base-monitoring'], function($, BaseMonitoring) {

    var MessageMonitoring = function() {
        // Call parent init method
        BaseMonitoring.apply(this, arguments);
    };

    // Inherit from MessageMonitoring
    for ( var element in BaseMonitoring.prototype) {
        MessageMonitoring.prototype[element] = BaseMonitoring.prototype[element];
    }

    MessageMonitoring.prototype.processResponse = function(result) {
        var lastTime = result.lastTime;
        var step = result.step;
        var data = [];
        var labels = ["Time"];
        var drawOptions = $.extend({
            stepPlot: true
        }, this.drawOptions);

        var tmpData = [];
        var transformers = [];
        if (this.wildcardKey) {
            // use scope in data to build labels
            for ( var key in result.data) {
                var d = result.data[key];
                tmpData.push(d);
                transformers.push(this.transformers[key] ? this.transformers[key] : this.identity);
                labels.push(drawOptions.labelTransformer ? drawOptions.labelTransformer(key) : key);
            }
        } else {
            // Keys and labels of a given mapping key have the same length
            for (var i = 0; i < this.mapping.keys.length; i++) {
                var key = this.mapping.keys[i];
                var d = result.data[key];
                if (d) {
                    tmpData.push(d);
                    transformers.push(this.transformers[key] ? this.transformers[key] : this.identity);
                    labels.push(this.mapping.labels[i]);
                }
            }
        }
        if (tmpData.length > 0) {
            // Data from a given mapping key have the same length
            for (var i = 0; i < tmpData[0].length; i++) {
                var dataRow = [];
                for (var j = 0; j < tmpData.length; j++) {
                    dataRow[j] = (isNaN(tmpData[j][i]) ? 0 : transformers[j](tmpData[j][i]));
                }
                // last time is in seconds and Date object in milliseconds
                var date = new Date();
                date.setTime((lastTime - step * (tmpData[0].length - 1 - i)) * 1000);
                data.push($.merge([date], dataRow));
            }
        }

        if (drawOptions.printTotal) {
            for (var d of data) {
                var tot = 0;
                for (var i = 1; i < d.length; i++) {
                    tot += d[i];
                }
                d.push(tot);
            }
            labels.push('Total');
        }
        
        return {
            data: data,
            labels: labels,
            drawOptions: drawOptions
        };
    };

    MessageMonitoring.removeArchive = function(key) {
        var colonPos = key.indexOf(':');
        return colonPos > -1 ? key.substring(colonPos + 1) : key;
    }

    MessageMonitoring.removeDomain = function(key) {
        var dotPos = key.indexOf('.');
        return dotPos > -1 ? key.substring(0, dotPos) : key;
    }

    MessageMonitoring.removeArchiveAndDomain = function(key) {
        return MessageMonitoring.removeDomain(MessageMonitoring.removeArchive(key));
    }

    return MessageMonitoring;
});

